var Cookies = require("js-cookie")


export const isAuthenticated = () => {
    try{
        // Check if token exists and token is valid
        const AUTH_TOKEN = Cookies.get("token")
        if (!AUTH_TOKEN){
            return false;
        }

        return true;
    }catch(err){
        console.log("err")
        return false
    }
}